<template>
  <modal
    size="md"
    :is-active="true"
    :title="$t('configurator.modals.titles.add_more_printable_articles')"
    @close="close">
    <template #body>
      <div class="articel-row">
        <div class="article-frame col-sm-12" v-for="article,index in articles" :key="article.id">
          <div class="article-inner-frame">
            <div class="article-thumb article-img-slider col-xs-4">
              <div class="article-img-frame" :data-featherlight="'/images/articles/' + article.images[article.currentImg].path" :style="{ 'background-image': 'url(/images/articles/' + article.images[article.currentImg].path + ')' }" v-if="article.images != null && article.images[article.currentImg]">
                <span v-if="article.images != null" class="prev-img fa fa-angle-left" v-show="article.images.length > 1" @click="article.currentImg = article.currentImg <= 0 ? article.images.length - 1 : article.currentImg - 1"></span>
                <span v-if="article.images != null" class="next-img fa fa-angle-right" v-show="article.images.length > 1" @click="article.currentImg = article.currentImg >= article.images.length - 1 ? 0 : article.currentImg + 1"></span>
              </div>
              <div class="article-img-frame" v-else></div>
            </div>
            <div class="article-info col-xs-8">
              <span class="article-label">{{ article.displayName }}</span>
              <article class="article-description">{{ article.displayDescription }}</article>
              <div class="action-row row">
                <span class="article-price col-xs-5">
                  {{ $filters.formatMoney(article.exhibitionPrices.price_net * lateDeliverySurcharge) }}
                  <small class="article-unit" v-bind:class="article.unit">
                    <span class="square_m">/m<sup>2</sup></span>
                    <span class="per_unit">{{ $t("booth_articles.per_unit") }}</span>
                  </small>
                </span>
                <div v-if="article.pivot.bookable && daysToGo > article.pivot.bookable_till_in_days" class="input-group input-group-sm col-xs-6" :key="changes">
                  <span class="input-group-btn">
                    <button
                      class="btn btn-primary btn-sm"
                      tabindex="-1"
                      type="button"
                      :disabled="article.count === 0"
                      @click="decreaseCount(index)">
                      <i class="fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </span>
                  <input
                    class="form-control"
                    type="number"
                    :step="1"
                    :min="0"
                    name="count"
                    v-model="article.count"
                    @blur="updateCount(index)">
                  <span class="input-group-btn">
                    <button
                      class="btn btn-primary btn-sm"
                      tabindex="-1"
                      type="button"
                      @click="increaseCount(index)">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                  </span>
                  <span class="input-group-btn" style="font-size:14px;">
                    <small class="article-unit" v-if="article.unit === 'sqm'">m<sup>2</sup></small>
                    <small class="article-unit" v-if="article.unit === 'pc'">&nbsp;&nbsp;</small>
                  </span>
                </div>
                <div v-else class="text-right">
                  {{ $t('article_not_available') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-warning mr-2" @click="close">
          {{ $t('configurator.buttons.cancel') }}
        </button>
        <button class="btn btn-primary" @click="submit">
          {{ $t('configurator.buttons.add_articles') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue'
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()
// define props
const props = defineProps({
  articles: {
    type: Array,
    default: []
  }
})
// define emits
const emit = defineEmits(['close', 'add'])
// define reactive props
const changes = ref(0)
// define computed props
const daysToGo = computed(() => store.tmp.days_to_go)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const lateDeliverySurcharge = computed(() => {
  return (earlyBirdMode.value)
    ? addLateDeliverySurcharge(1, lateDelivery.value)
    : 1
})
// define methods
const submit = (() => {
  const articlesWithCount = props.articles.filter((article) => {
    return article.count > 0
  })
  emit('add', articlesWithCount)
})

const close = (() => {
  emit('close')
})

const increaseCount = (index) => {
  props.articles[index].count += 1
  changes.value++
}

const decreaseCount = (index) => {
  props.articles[index].count -= 1
  changes.value++
}

const updateCount = (index) => {
  if (props.articles[index].count < 0) {
    props.articles[index].count = 0
  }
  changes.value++
}

onMounted(() => {
  props.articles.forEach((article) => {
    article.count = 0
    article.uses = 0
  })
})
</script>